import React from 'react';
import './index.scss';

import {
  BUTTON_NO_PREV,
  BUTTON_DEFAULT,
  BUTTON_CONF,
  BUTTON_BACKLP,
  BUTTON_NONE,
} from 'utils/constant';
import NextButton from 'components/atoms/Button/NextButton';
import PrevButton from 'components/atoms/Button/PrevButton';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';

const empty = () => {};

const SpButtonArea = ({
  onClickMainButton = {},
  nextUrl,
  prevUrl,
  valid,
  buttonType,
}) => {

  const prevClick = onClickMainButton.prev ? (e) => onClickMainButton.prev(e) : empty;
  const nextClick = onClickMainButton.next ? (e) => onClickMainButton.next(e) : empty;
  
  // 次へのみのボタン
  const NoPrevButton = () => (
    <>
      <div className="nextOnly">
        <NextButton label='下記に同意して確認画面へ' onClick={nextClick} link={nextUrl} valid={valid} />
      </div>
      <div className="privacy-pollicy">
        <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
        ・
        <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
        ・
        <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
        {' '}
        にご同意いただいたうえで送信してください。
      </div>
    </>
  );

  // 標準のボタン
  const DefaultButton = () => (
    <>
      <div className="next">
        <NextButton label='この内容で依頼する' link={nextUrl} onClick={nextClick} valid={valid} />
      </div>
      <div className="prev">
        <PrevButton label='入力内容を修正する' link={prevUrl} onClick={prevClick} />
      </div>
    </>
  );

  // 確認画面のボタン
  const ConfButton = () => (
    <>
      <div className="next">
        <NextButton label='この内容で依頼する' link={nextUrl} onClick={nextClick} valid={valid} />
      </div>
      <div className="prev">
        <ClickOnlyButton label='戻る' color='white' onClick={prevClick} valid/>
      </div>
      <div className="privacy-pollicy">
        <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
        ・
        <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
        ・
        <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
        {' '}
        にご同意いただいたうえで送信してください。
      </div>
    </>
  );
  // LPに戻るボタン
  const BackLpButton = () => (
    <>
      <div className="backLp">
        <PrevButton label='戻る' link={nextUrl} onClick={nextClick} />
      </div>
    </>
  );

  const FooterButtons = {
    [BUTTON_DEFAULT]: <DefaultButton />,
    [BUTTON_NO_PREV]: <NoPrevButton />,
    [BUTTON_CONF]: <ConfButton />,
    [BUTTON_BACKLP]: <BackLpButton />,
    [BUTTON_NONE]: '',
  };
  return (
    <div className="SpButtonArea" id="FooterButtons">
      <div className="wrapper">
        <div className="button-area">
          {FooterButtons[buttonType]}
        </div>
      </div>
    </div>
  );
};

export default SpButtonArea;